var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "button",
      {
        staticClass: "btn btn-primary d-none",
        attrs: {
          type: "button",
          "data-bs-toggle": "modal",
          "data-oevent-category": _vm.actionTms.category,
          "data-oevent-action": _vm.actionTms.action,
          "data-oevent-label": _vm.actionTms.label,
          "data-bs-target": "#" + _vm.id,
        },
      },
      [_vm._v("Information")]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal modal-feedback fade",
        attrs: {
          id: _vm.id,
          tabindex: "-1",
          role: "dialog",
          "aria-labelledby": _vm.labelId,
          "aria-hidden": "true",
          "data-ob1-component": "Popin",
        },
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog", attrs: { role: "document" } },
          [
            _c("div", { staticClass: "modal-content" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _c("div", { staticClass: "feedback" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "ob1-feedback-content" },
                    [
                      _vm.modalTitle
                        ? _c("h4", {
                            directives: [
                              {
                                name: "safe-html",
                                rawName: "v-safe-html",
                                value: _vm.modalTitle,
                                expression: "modalTitle",
                              },
                            ],
                            staticClass: "h3",
                            attrs: { id: _vm.labelId },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.modalContent
                        ? _c("p", {
                            directives: [
                              {
                                name: "safe-html",
                                rawName: "v-safe-html",
                                value: _vm.modalContent,
                                expression: "modalContent",
                              },
                            ],
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._t("actionButton"),
                    ],
                    2
                  ),
                ]),
              ]),
            ]),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "button",
        {
          staticClass: "btn-close d-none",
          attrs: {
            type: "button",
            "data-bs-dismiss": "modal",
            "aria-label": "Fermer",
          },
        },
        [
          _c("span", {
            staticClass: "icon icon-delete",
            attrs: { "aria-hidden": "true" },
          }),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "ob1-feedback-functional-icon" }, [
      _c("div", { staticClass: "alert alert-info" }, [
        _c("span", {
          staticClass: "alert-icon",
          attrs: { "aria-hidden": "true" },
        }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }